/** @jsx jsx */
import { jsx } from "@emotion/core";
import * as React from "react";
import {
  PropValuesEnum,
  feeStructureDetails,
  routeURL,
} from "../../constants/commons";
import {
  singleSectionStyles,
  feeContainerStyles,
  responsiveStyles,
} from "../../commons/styles";
import { ResponsiveWidget } from "../../components/ResponsiveWidget";
import { feeStructurePageStyle } from "./styles";
import { useHistory } from "react-router-dom";
import backIcon from "../../assets/back-arrow.svg";
import { useIsMobile } from "../../hooks/useIsMobile";

interface IFeeStructureProps {}

export const FeeStructure: React.FC<IFeeStructureProps> = (
  props: IFeeStructureProps
) => {
  const history = useHistory();
  const isMobile = useIsMobile();

  const getFeeContent = React.useCallback(() => {
    return (
      <div>
        {feeStructureDetails.map((item, key) => {
          return (
            <div key={key} className="payment-service-type-section">
              <h5 className="payment-service-type">
                {item.type}
                <hr />
              </h5>
              <ResponsiveWidget
                align={
                  isMobile ? PropValuesEnum.VERTICAL : PropValuesEnum.HORIZONTAL
                }
              >
                {item.content.map((e, i) => {
                  return (
                    <div key={i} className="fee-structure-body">
                      <div className="d-flex align-items-center mb-4">
                        <img src={e.imgURL} alt="" />
                        <h5>{e.heading}</h5>
                      </div>

                      <div className="text-container mb-3">{e.body}</div>
                    </div>
                  );
                })}
              </ResponsiveWidget>
            </div>
          );
        })}
      </div>
    );
  }, [isMobile]);

  // Function which is called when the back button in the registration screen is clicked
  const redirectToLandingPage = () => {
    history.push(routeURL.landingPage);
  };

  return (
    <span css={[responsiveStyles, feeStructurePageStyle]}>
      <div
        className="single-section fee-structure-container"
        css={[singleSectionStyles(), feeContainerStyles]}
      >
        <button
          onClick={redirectToLandingPage}
          className="border-0 user-button-style bg-none p-0"
        >
          <div className="d-flex align-items-center mb-5 p-0">
            <img src={backIcon} alt="" className="back-button" />
            <div className="ml-2 back-button-style">BACK</div>
          </div>
        </button>

        <div className="header-container mb-4">
          <div>
            <h2> Fee Structure</h2>
            <h6>Grow and Earn with Cult.fit</h6>
          </div>
        </div>

        {getFeeContent()}
      </div>
    </span>
  );
};
